//Appbar taken from MUI - https://mui.com/material-ui/react-app-bar/

import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import Modal from 'react-modal';


const drawerWidth = 240;
// the navigation bar along the top of the app or pop out from the side for mobile
export default function DrawerAppBar(props) {
  const navigate = useNavigate();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const { currentStaff, loading, error } = useSelector((state) => state.staff);
  const [navItems, setNavItems] = useState(['Menu', 'Current Order', 'Review Bill', 'Staff', 'Request Assistance', 'Cancel Assistance Request']);

  const [popupOpen, setPopupOpen] = useState(false);
  const [popupText, setPopupText] = useState("Hi");
  const [popupTitle, setPopupTitle] = useState("Hi");

  const openPopup = () => {
    setPopupOpen(true);
  };

  const closePopup = () => {
    setPopupOpen(false);
  };

  useEffect(() => {
    const showPermittedLinks = async () => {
      if (currentStaff) {
        let newNav = [...navItems];

        if (!navItems.includes('WaitStaff') && !navItems.includes('KitchenStaff')) {
          newNav.unshift('WaitStaff', 'KitchenStaff');
        }
        
        newNav = newNav.filter(item => item !== 'Staff')
        newNav.push(currentStaff.employee_id);
        setNavItems(newNav);
      } else {
        let newNav = [...navItems];
        
        newNav = newNav.filter(item => isNaN(item) )
        newNav = newNav.filter(item => item !== 'WaitStaff')
        newNav = newNav.filter(item => item !== 'KitchenStaff')

        if (!newNav.includes('Staff')) {
          newNav.push('Staff');
        }
        setNavItems(newNav);
      }
    };
    showPermittedLinks();
  }, [currentStaff])

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const move = async (page) => {
    if (page === 'Menu') {
      navigate('/menu')
    } else if (page === 'Current Order') {
      navigate('/order')
    } else if (page === 'Review Bill') {
      navigate('/bill')
    } else if(page === 'Staff' || !isNaN(page)) {
      navigate('/profile')
    } else if(page === 'WaitStaff') {
      navigate('/wait-staff-page')
    } else if (page === 'KitchenStaff') {
      navigate('kitchen-staff-page')
    } else if (page === 'Request Assistance') {
      try {
        let tableNo = localStorage.getItem('tableNo');
        const res = await fetch(`/wait_staff/requestAssistance?tableNumber=${tableNo}`, {
          method: 'GET'
        })
        setPopupText("Assistance request has been sent. We'll be with you shortly");
        setPopupTitle("Success!");
        setPopupOpen(true);
      } catch (err) {
        // console.log(categoryPosition + position);
        console.log(err.message);
        setPopupTitle("Request Failed");
        setPopupText("Assistance request has failed to send, please try again.");
        setPopupOpen(true);
      }
    } else if (page === 'Cancel Assistance Request') {
      try {
        let tableNo = localStorage.getItem('tableNo');
        const res = await fetch(`/wait_staff/cancelAssistance?tableNumber=${tableNo}`, {
          method: 'POST'
        })
        setPopupTitle("Success!");
        setPopupText("Assistance request has been cancelled sucessfully");
        setPopupOpen(true);
      } catch (err) {
        // console.log(categoryPosition + position);
        console.log(err.message);
        setPopupTitle("Request Failed");
        setPopupText("Assistance request has failed to cancel, please try again.");
        setPopupOpen(true);
      }
    }
  }

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        Rock Throwers
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }} onClick={() => move(item)}>
              <ListItemText primary={item}  />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const popupStyling = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      boxShadow: '0px 0px 1px',
      borderRadius: '8px',
      padding: '23px',
      backgroundColor: '#fff',
      maxWidth: '400px',
      width: '90%',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
    },
  };

  const buttonStyling = {
   backgroundColor: "black",
   color: "white",
   width: "100px",
   height: "30px",

   borderRadius: '4px',
  }

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar component="nav" sx={{ backgroundColor: 'black'}}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
          >
            Rock Throwers
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            {navItems.map((item) => (
              <Button key={item} sx={{ color: '#fff' }} onClick={() => move(item)}>
                {item}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, backgroundColor: 'black', color: 'white' },
          }}
        >
          {drawer}
        </Drawer>
        <div>
          <Modal
            isOpen={popupOpen}
            onRequestClose={closePopup}
            contentLabel="Example Modal"
            style={popupStyling}
          >
            <h1>{popupTitle}</h1>
            <p>{popupText}</p>
            <button onClick={closePopup} style={buttonStyling}>CLOSE</button>
          </Modal>
        </div>
      </nav>
    </Box>
  );
}

DrawerAppBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};